import React from 'react';
import { ReadOnlyItem } from '@ydistri/ds';
import { formatDate } from '@ydistri/generic-utils';

interface EntityListArchivationInfoProps {
  archived?: boolean;
  archivedAt?: string | null;
  scheduledArchivedOn?: string | null;
  labelWidth?: string;
}

/**
 * Shows data about archivation of the entity list. Only User entity lists can be archived.
 * @param archived
 * @param scheduledArchivedOn
 * @param archivedAt
 * @param labelWidth
 * @constructor
 */
const EntityListArchivationInfo: React.FC<EntityListArchivationInfoProps> = ({
  archived = false,
  scheduledArchivedOn,
  archivedAt,
  labelWidth,
}) => {
  if (archived) {
    return (
      <ReadOnlyItem
        label="Archived at"
        value={archivedAt ? formatDate(archivedAt) : '-'}
        labelWidth={labelWidth}
      />
    );
  } else {
    return (
      <ReadOnlyItem
        label="Scheduled archivation"
        value={scheduledArchivedOn ? formatDate(scheduledArchivedOn) : 'never'}
        labelWidth={labelWidth}
      />
    );
  }
};

export default EntityListArchivationInfo;
